<router-outlet></router-outlet>

<app-loading-component (onLoaded)="OnLoadingLoaded($event)"></app-loading-component>
